import React from "react";

import { Panel } from 'primereact/panel';

const Inicio = () => {

    return (
        <React.Fragment>
            <Panel header="RPMI System">
                <div style={{ fontSize: '1.17em', paddingTop: '1.4rem' }}>
                    Bem-Vindo
                </div>
            </Panel>
        </React.Fragment>
    )
}

export default Inicio;